module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.name) ? _c('p', {
    staticClass: "without without_warn"
  }, [_vm._v("Извините, сертификат может быть получен только на ребенка в возрасте от 5 до 17 лет.")]) : (_vm.needActivate && !_vm.isApproved) ? _c('p', {
    staticClass: "without"
  }, [_vm._v("Для активации сертификата, пожалуйста, подтвердите данные ребенка согласно "), _c('router-link', {
    attrs: {
      "to": _vm.toConfirm
    }
  }, [_vm._v("инструкции")]), _vm._v(". После подтверждения данных вы сможете активировать сертификат.")], 1) : (_vm.isApproved) ? _c('p', {
    staticClass: "without"
  }, [_vm._v("Данные о ребенке подтверждены, но сертификат пока не активирован.\nТеперь вы можете подать заявление на активацию сертификата\n(включение ребенка в систему персонифицированного финансирования)\nв личном кабинете или обратиться в любое учреждение дополнительного образования.")]) : _c('p', {
    staticClass: "without without_good"
  }, [_vm._v("Вы можете получить сертификат на имя " + _vm._s(_vm.name) + ".")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0adc36e1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/withoutcert/WithoutCert.vue
// module id = 0197e605e980ba0732d7
// module chunks = 9